// extracted by mini-css-extract-plugin
export default {"message-icon":"_-_-_-plugins-jacow-indico_jacow-client-___PeerReviewManagerFileInput-module__message-icon___Ir30n"};